<template>
  <div class="pass">
    <div class="pass-login">
      <div class="pass-img"></div>
      <div class="pass-content">
        <div class="light">
          <img src="@/assets/lianght.png" alt />
        </div>
        <div class="content-font">船员平台登录</div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="pass-form"
        >
          <el-form-item prop="loginName" style="margin-top: 2.9186rem">
            <el-input
              v-model="ruleForm.loginName"
              autocomplete="off"
            ></el-input>
            <img src="@/assets/username.png" alt class="login-img" />
          </el-form-item>
          <el-form-item prop="plainPassword" style="margin-top: 2.0714rem">
            <el-input
              type="password"
              v-model="ruleForm.plainPassword"
              autocomplete="off"
            ></el-input>
            <img src="@/assets/password.png" alt class="pss-img" />
          </el-form-item>
          <el-form-item style="margin-top: 1.8714rem">
            <div class="flex login-tip">
              <el-checkbox v-model="checkPassword">记住密码</el-checkbox>
              <p>
                <a @click="toPage()" style="cursor: pointer">船员平台首页</a>
              </p>
            </div>
          </el-form-item>
          <el-form-item style="margin-top: 1.8714rem">
            <el-button
              type="primary"
              class="login-button"
              @click="login('ruleForm')"
              >登录</el-button
            >
          </el-form-item>
          <el-form-item style="margin-top: 1rem">
            <p class="go-home">
              <a @click="gotoReg()" style="cursor: pointer">没有账号?去注册</a>
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { setStorage } from "@/utils/auth";
import { MD5 } from "@/utils/md5.js";
import { login, getLobarShipMappingUserToken } from "@/apis/index";
const Base64 = require("js-base64").Base64;
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      activeName: "first",
      ruleForm: {},
      rules: {
        loginName: [{ validator: this.validateUser, trigger: "blur" }],
        plainPassword: [{ validator: this.validatePass, trigger: "blur" }],
      },
      checkPassword: false,
    };
  },
  mounted() {
    let username = localStorage.getItem("username");
    if (username) {
      this.$set(this.ruleForm, "loginName", localStorage.getItem("username"));
      let passSecond = Base64.decode(localStorage.getItem("password"));
      this.$set(this.ruleForm, "plainPassword", passSecond);
      this.checkPassword = true;
    }
  },
  created() {
    this.test = process.env.NODE_ENV;
    this.url = process.env.VUE_APP_BASE_URL;
  },
  methods: {
    validateUser(rule, value, callback) {
      if (!value) {
        this.userTrue = false;
        return callback(new Error("用户名不能为空"));
      } else {
        this.userTrue = true;
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else {
        callback();
      }
    },
    async loginUser() {
      if (this.checkPassword == true) {
        let password = Base64.encode(this.ruleForm.plainPassword); // base64加密
        localStorage.setItem("username", this.ruleForm.loginName);
        localStorage.setItem("password", password);
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
      }
      const res = await login({
        plainPassword: MD5(this.ruleForm.plainPassword),
        loginName: this.ruleForm.loginName,
      });
      if (!res.code) {
        this.$message({
          message: "用户名或密码错误",
          type: "warning",
        });
      } else if (res.code == "1") {
        sessionStorage.setItem(
          "tolog",
          this.ruleForm.loginName + "split" + MD5(this.ruleForm.plainPassword)
        );
        var data = res.data;
        if (
          data.companyType == "0" &&
          data.userType == "0" &&
          data.isLand == "1" &&
          data.isRecruitSystemAdmin == "1"
        ) {
          data.menuType = 1;
        } else if (data.companyType == "2" && data.userType == "5") {
          data.menuType = 1;
        } else if (
          data.companyType == "0" &&
          data.userType == "0" &&
          data.isRecruitSystemAdmin == "0"
        ) {
          data.menuType = 2;
        } else if (data.userType == "4") {
          data.menuType = 2;
        }
        setStorage(data);
        sessionStorage.setItem("agenToken", data.token);
        this.getDutyListList();
        if (res.data.userType == "2") {
          this.$router.push("/declarationReview");
        } else if (res.data.userType == "9" && res.data.companyType == "9") {
          this.$router.push("/otherHome");
        } else {
          this.toPage();
        }
      }
    },
    async getDutyListList() {
      const res = await getLobarShipMappingUserToken({
        lobarCompanyId: sessionStorage.getItem("companyId"),
        shipCompanyId: "8f42b387b3ae4a8686e0afc79ed59343",
      });
      if (res.code == "1") {
        sessionStorage.setItem("otherToken", res.data);
      }

      // this.companyList = res.data;
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log("1");
          this.loginUser();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toPage() {
      window.scrollTo({
        top: 0,
      });
      this.$router.push("/home");
      this.$forceUpdate();
    },
    gotoReg() {
      window.scrollTo({
        top: 0,
      });
      this.$router.push("/register");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
